import React from 'react';
import { motion } from 'framer-motion';
import { Layers, Code2, Palette, TrendingUp } from 'lucide-react';
import { Card } from '../ui/Card';
import { Section } from '../ui/Section';
export function ServicesSection() {
  const services = [{
    title: 'Digital Product Design',
    description: 'UI/UX design, interfaces, design systems, user-focused experiences.',
    icon: <Layers className="w-6 h-6 text-[#00316B]" data-id="element-156" />
  }, {
    title: 'Web & App Development',
    description: 'Modern, scalable, high-performing websites and applications.',
    icon: <Code2 className="w-6 h-6 text-[#00316B]" data-id="element-157" />
  }, {
    title: 'Brand & Visual Identity',
    description: 'Logos, brand systems, visual assets, and design direction.',
    icon: <Palette className="w-6 h-6 text-[#00316B]" data-id="element-158" />
  }, {
    title: 'Digital Growth & Strategy',
    description: 'Marketing, optimization, campaigns, and digital performance.',
    icon: <TrendingUp className="w-6 h-6 text-[#00316B]" data-id="element-159" />
  }];
  return <Section id="services" background="white" data-id="element-160">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-161">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold font-heading text-[#0C0C0C] mb-6" data-id="element-162">
          What We Do
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg text-gray-600 leading-relaxed" data-id="element-163">
          We combine strategy, design, and technology to build digital solutions
          that are not only visually refined, but built to perform.
        </motion.p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-164">
        {services.map((service, index) => <motion.div key={service.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} data-id="element-165">
            <Card className="h-full hover:border-[#00316B]/20 transition-colors duration-300" data-id="element-166">
              <div className="flex items-start space-x-4" data-id="element-167">
                <div className="p-3 bg-[#F8F8F6] rounded-lg border border-gray-100 shrink-0" data-id="element-168">
                  {service.icon}
                </div>
                <div data-id="element-169">
                  <h3 className="text-xl font-bold font-heading text-[#0C0C0C] mb-3" data-id="element-170">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-171">
                    {service.description}
                  </p>
                </div>
              </div>
            </Card>
          </motion.div>)}
      </div>
    </Section>;
}